export const BASE_URL =
  'https://my-json-server.typicode.com/yisu-kim/pre-onboarding-paywork/';

export const TODO_URL = 'todo';
